import logo from 'assets/logo.png';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import userManager from 'utils/userManager';
import { withRouter } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import Delay from 'layoutComponents/Delay';
import log from 'utils/logger';
import localForage from 'localforage';

const logger = log('loginPage');

export class LoginPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.onLoginButtonClick = this
            .onLoginButtonClick
            .bind(this);
    }

    onLoginButtonClick(event) {
        event.preventDefault();

        logger.info(`Clicked login with redirect uri ${this.props.location.pathname}`);

        localStorage.clear();

        const appStore = localForage.createInstance({ name: "app_store" });
        const tokenStore = localForage.createInstance({ name: "token_store" });
        const userStore = localForage.createInstance({ name: "user_store" });

        return appStore
            .clear()
            .then(() => {
                return tokenStore
                    .clear()
                    .then(() => {
                        return userStore
                            .clear()
                            .then(() => {
                                userManager.signinRedirect({
                                    data: {
                                        redirectUrl: this.props.location.pathname
                                    }
                                });
                            });
                    });
            });
    }

    render() {
        const { user } = this.props;
        if (user && user.get('userId')) {
            return (
                <div>
                    <p>Welcome {user.get('name')}. You are already logged in.</p>
                </div>
            );
        }
        return (
            <div>
                <Delay wait={1500}>
                    <div>
                        <h4 style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <img src={logo} alt="Logo" style={{ height: 32, marginRight: 8 }} />
                            Field Service Tool
                        </h4>
                        <br />
                        <RaisedButton label="Login" primary onTouchTap={this.onLoginButtonClick} />
                    </div>
                </Delay>
            </div>

        );
    }

}

LoginPage.propTypes = {
    location: PropTypes.object,
    user: PropTypes.object
};

function mapDispatchToProps(dispatch) {
    return {
        push: bindActionCreators(push, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        user: state.get('user')
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginPage));



// WEBPACK FOOTER //
// ./src/containers/pages/LoginPage.js